export default {
  name: '',
  active: true,
  color: 0,
  mapImageUrl: null,
  siteId: '',
}
